module.exports = __webpack_public_path__ + "pintora/simplenode-c93e844c11443bfe.svg";